export default "__VITE_ASSET__DJY1pwyC__"